function getContextVariableLocalStorage() {
  const todosOsItens = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    let chave = localStorage.key(i);
    let valor = localStorage.getItem(chave);
    todosOsItens.push({ name: chave, value: valor, type: 'DEFINE_VALUE' });
  }
  return todosOsItens;
}

export { getContextVariableLocalStorage };